import Api from '@/modules/core/api/api.ts';
import type { CityDto } from '@/modules/counterparty/dto/city.dto.ts';
import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import { CityAdapter } from '@/modules/counterparty/adapters/city.adapter.ts';
import { CityEndPoint } from '@/modules/counterparty/enums/counterparty-end-point.enum.ts';
import { RequestUtil } from '@/modules/core/utils/request.util.ts';
import { Direction } from '@/modules/common/enums/direction.enum.ts';

export class CityApi {
  static async getList(signal: AbortSignal) {
    const response: ItemsDto<CityDto> = await Api.post(
      CityEndPoint.GetList,
      RequestUtil.orderBy('Город', Direction.Asc),
      signal
    );
    return CityAdapter.mapList(response);
  }
}
